module.exports = __webpack_public_path__ + "img/facebook_messenger_with_beak.cbf27ceb.svg";